import { k as keys } from '../keyboardKeynames-04a50e15-b033061a.js';
import { g as getFocusableElements } from './getFocusableElements-73f83f90-0ab4a5e4.js';

function trapTabFocus(event, context, includeParent = false) {
  const {
    key,
    shiftKey
  } = event;
  if (context) {
    const focusableEls = getFocusableElements(context);
    const firstFocusableEl = !includeParent ? focusableEls[0] : context;
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    // trap focus for tab
    if (key === keys.TAB && !shiftKey) {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        event.preventDefault();
      }
    }

    // trap focus for shift + tab
    if (key === keys.TAB && shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        event.preventDefault();
      }
    }
  }
}

export { trapTabFocus as t };
//# sourceMappingURL=trapTabFocus-c2676751-9f3167b4.js.map
